module.exports = __webpack_public_path__ + "static/img/10.44a2683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/10.png
// module id = 3Ke4
// module chunks = 35